export { default } from "../src/cache";
